import React from 'react'

interface IItemProps {
  value: string
}

const AutocompleteItem: React.FC<IItemProps> = ({ value }) => {
  const url = '/search/?q=' + value.replaceAll(' ', '+')

  return (
    <li className="npf-autocomplete__item">
      <a href={url}>{value}</a>
    </li>
  )
}
export default AutocompleteItem
